import { Input } from "@/components/ui/input";
import { CalendarClock } from "lucide-react";

const todayBR = () => new Date().toLocaleDateString("en-CA", { timeZone: "America/Sao_Paulo" });
const addDays = (iso, n) => { const d = new Date(`${iso}T12:00:00Z`); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };
const fmt = (iso) => iso.split("-").reverse().join("/");
const planEnd = (start, p) => (p?.duration_days > 0 ? addDays(start, p.duration_days - 1) : addDays(start, 30 * (p?.duration_months || 1)));

export const SellStartDate = ({ plan, custom, setCustom, date, setDate, disabled }) => {
  const today = todayBR();
  const min = addDays(today, -60), max = addDays(today, 60);
  const end = custom && date ? planEnd(date, plan) : null;
  const diff = date ? Math.round((new Date(`${date}T12:00:00Z`) - new Date(`${today}T12:00:00Z`)) / 86400000) : 0;
  return (
    <div className="mt-3 rounded-lg border border-slate-200 bg-slate-50 p-3" data-testid="detail-start-panel">
      <label className="inline-flex items-center gap-2 cursor-pointer">
        <input type="checkbox" checked={custom} disabled={disabled} onChange={(e) => { setCustom(e.target.checked); if (e.target.checked && !date) setDate(today); }} className="w-4 h-4 accent-rose-600" data-testid="detail-start-toggle"/>
        <CalendarClock className="w-4 h-4 text-slate-600"/>
        <span className="font-heading text-sm font-bold text-slate-900 uppercase tracking-wider">Escolher data de início</span>
        <span className="text-xs text-slate-500">(retroativa ou futura, até 60 dias)</span>
      </label>
      {disabled && <p className="text-[11px] text-slate-500 mt-1">Indisponível no Pix Mercado Pago.</p>}
      {!custom && !disabled && <p className="text-[11px] text-slate-500 mt-1" data-testid="detail-start-auto">Padrão: continua do vencimento atual (se ainda válido) ou começa hoje.</p>}
      {custom && !disabled && (
        <div className="flex items-center gap-3 flex-wrap mt-2">
          <Input type="date" value={date} min={min} max={max} onChange={(e) => setDate(e.target.value)} className="w-44 bg-white" data-testid="detail-start-date"/>
          {date && (date < min || date > max) && <span className="text-xs font-bold text-rose-700" data-testid="detail-start-range-error">Fora do limite de 60 dias</span>}
          {end && date >= min && date <= max && (
            <span className={`text-xs font-bold ${end < today ? "text-rose-700" : "text-slate-700"}`} data-testid="detail-start-preview">
              Início {fmt(date)} ({diff === 0 ? "hoje" : diff < 0 ? `${-diff} dia(s) atrás` : `daqui ${diff} dia(s)`}) · vence {fmt(end)}{end < today ? " — plano já nasceria vencido, a venda será bloqueada" : ""}
            </span>
          )}
        </div>
      )}
      {custom && !disabled && <p className="text-[11px] text-slate-500 mt-1">O pagamento entra no caixa de hoje; só a validade do plano muda.</p>}
    </div>
  );
};
